import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=14b43ca2&scoped=true"
import script from "./ProductCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductCard.vue?vue&type=style&index=0&id=14b43ca2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b43ca2",
  null
  
)

export default component.exports